import Cookies from "js-cookie";

$(document).on("ready turbo:load", function () {
  function openCookieModal() {
    $("#cookie-settings-modal").prop("checked", true).trigger("change");
  }

  function closeCookieModal() {
    console.log("close cookie modal");
    $("#cookie-settings-modal").prop("checked", false).trigger("change");
  }

  function acceptAllCookies() {
    Cookies.set(
      "good_travel_cookie_consent",
      JSON.stringify({
        required: true,
        marketing: true,
        statistics: true,
      }),
      {
        expires: 365,
      },
    );

    window.setGtagConsent("update");
  }

  $("#cbv2 button#accept_all_cookies").click(function () {
    acceptAllCookies();
    $("#cbv2").hide();
  });

  $("#cookie_settings_form button#modal_accept_all_cookies").click(function () {
    acceptAllCookies();
    closeCookieModal();
  });

  $("#cookie_settings_form").submit(function (event) {
    event.preventDefault();

    var marketingAllowed = $("input[name=marketing]").prop("checked");
    var statisticsAllowed = $("input[name=statistics]").prop("checked");

    Cookies.set(
      "good_travel_cookie_consent",
      JSON.stringify({
        required: true,
        marketing: marketingAllowed,
        statistics: statisticsAllowed,
      }),
      {
        expires: 365,
      },
    );

    window.setGtagConsent("update");

    closeCookieModal();
    $("#cbv2").hide();
    return false;
  });

  $("#cbv2 a#cookie_settings").click(function (event) {
    event.preventDefault();

    openCookieModal();
    return false;
  });
});
